import * as yup from 'yup';

export const brokerFirmNameValidation = yup
  .string()
  .nullable()
  .when('isAffiliatedExchangeOrFINRA', {
    is: true,
    then: yup
      .string()
      .nullable()
      .required('Please enter a valid broker deal firm'),
  });
